import React from 'react';
import { Typography, Grid, Card, CardContent, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import StorageIcon from '@mui/icons-material/Storage';

const ExecutiveSummary = () => {
  return (
    <section id="executive-summary" className="whitepaper-section">
      <Typography variant="h2" className="section-title">
        Executive Summary
      </Typography>
      
      <Card className="highlight-card" sx={{ mb: 4, background: 'linear-gradient(135deg, rgba(0,180,160,0.1) 0%, rgba(30,144,255,0.1) 100%)', border: '2px solid rgba(96,165,250,0.3)' }}>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ color: '#60a5fa', fontWeight: 700 }}>
            The Problem
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box className="problem-item">
                <TrendingUpIcon sx={{ color: '#ef4444', fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Escalating Costs</Typography>
                <Typography>SIEM pricing models result in 40-60% annual cost increases</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="problem-item">
                <SpeedIcon sx={{ color: '#f59e0b', fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Performance Degradation</Typography>
                <Typography>High-velocity data streams cause search delays and missed detections</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="problem-item">
                <SecurityIcon sx={{ color: '#8b5cf6', fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Alert Fatigue</Typography>
                <Typography>False positives overwhelm security analysts</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box className="problem-item">
                <StorageIcon sx={{ color: '#3b82f6', fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Compliance Gaps</Typography>
                <Typography>Lack of complete audit trails and data lineage tracking</Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card className="highlight-card" sx={{ mb: 4, background: 'linear-gradient(135deg, rgba(16,185,129,0.1) 0%, rgba(59,130,246,0.1) 100%)', border: '2px solid rgba(16,185,129,0.3)' }}>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ color: '#10b981', fontWeight: 700 }}>
            The Solution
          </Typography>
          <Grid container spacing={2}>
            {[
              'Reduce SIEM costs by 40-70% through intelligent filtering',
              'Process millions of events per second with zero data loss',
              'Enrich events in real-time with threat intelligence',
              'Maintain complete compliance with comprehensive audit trails',
              'Improve detection capabilities through advanced correlation'
            ].map((benefit, index) => (
              <Grid item xs={12} key={index}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CheckCircleIcon sx={{ color: '#10b981', fontSize: 30 }} />
                  <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>{benefit}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </section>
  );
};

export default ExecutiveSummary;
